// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9c926450","686":"4fb1e516"}[chunkId] + ".chunk.js";
};